import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';
import ModalTarifas from './ModalTarifas';

const database=firebase.database();


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class Tarifas extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			
			tarifas:[],
			isActive:false,
			tarifaKey:'',
			monto:'',
			d_5km:'',
			d_10km:'',
			d_15km:'',
			d_mas15km:'',
			distancia:'',
			nombreTarifa:'',
			uidEmpresa:'',
			tipoServicio:'',
			template:false
			
		}
		
		this.toggleModal=this.toggleModal.bind(this);
		this.tarifasRef=database.ref().child('Tarifas');
		this.btnEditarFormatter=this.btnEditarFormatter.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleChange=this.handleChange.bind(this);
		this.submitUpdate=this.submitUpdate.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.submitUpdate();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
	
	}
	
	
	handleClickAlerta(event){
		this.setState({
			template:true			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	
	componentWillMount(){
		
		
	}
	
	componentDidMount(){
		
		
		this.tarifasRef.on('value', this.gotData, this.errData);
		
	}
	


	//get the data from the firebase and push them out
	gotData = (data) => {
		
		 
		  let newTarifa = [];
		  if(data.val()!==null){
			const tarifasdata = data.val();
			const keys = Object.keys(tarifasdata);

			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				
		
				newTarifa.push({
				key:k,			  
				nombreTarifa:tarifasdata[k].nombre_tarifa,
				uidEmpresa:tarifasdata[k].uid_empresa,
				d_5km:tarifasdata[k].d_5km,
				d_10km:tarifasdata[k].d_10km,
				d_15km:tarifasdata[k].d_15km,
				d_mas15km:tarifasdata[k].d_mas15km
				
				});
			}
			}
		  this.setState({tarifas: newTarifa});
		}
		errData = (err) => {
	      console.log(err);
	    }

	
	handleClick(row){
		
		this.setState({
			
			tarifaKey:row.key,
			nombreTarifa:row.nombreTarifa,
			uidEmpresa:row.uidEmpresa,
			d_5km:row.d_5km,
			d_10km:row.d_10km,
			d_15km:row.d_15km,
			d_mas15km:row.d_mas15km
			
		});
		
		this.toggleModal();
	}
	
	handleChange(){
		
		let opcion=this.tipoServicio.value;
		
		this.setState({
			
			tipoServicio:opcion
			
			
		});
		
		
		
	}
	
	
	toggleModal(){
		
		this.setState({
		
			isActive:!this.state.isActive
						
		});
		
	}
	
	btnEditarFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	submitUpdate(){
		
		let d_5km=this.d_5km.value;
		let d_10km=this.d_10km.value;
		let d_15km=this.d_15km.value;
		let d_mas15km=this.d_mas15km.value;
		
		
		this.tarifasRef.child(this.state.tarifaKey).update({
			
			d_5km:d_5km,
			d_10km:d_10km,
			d_15km:d_15km,
			d_mas15km:d_mas15km
		})
		
		Alert.success('Datos actualizados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
		});	
		
		this.toggleModal();
		
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		
		return(
		
	
				<div className="tarifas container" onClick={this.ocultarMenu}>
			
			
					<h1 className="titulo">Tarifas</h1>
			
					<ModalTarifas/>
					{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido.bind(this)}/>:<Alert stack={{limit: 3}} html={true} />}
					<BootstrapTable data={ this.state.tarifas}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombreTarifa' dataSort={true}  >Nombre Tarifa</TableHeaderColumn>
						 <TableHeaderColumn dataField='d_5km' dataSort={true}  dataAlign='center'>5 Km </TableHeaderColumn>
						 <TableHeaderColumn dataField='d_10km' dataSort={true}  dataAlign='center'>10 Km </TableHeaderColumn>
						 <TableHeaderColumn dataField='d_15km' dataSort={true}  dataAlign='center'>15 Km </TableHeaderColumn>
						 <TableHeaderColumn dataField='d_mas15km' dataSort={true}  dataAlign='center'>Mayor a 15 Km </TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEditarFormatter.bind(this) }>Editar</TableHeaderColumn>
					</BootstrapTable>
			
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
						<h3>Modificar Tarifa</h3>
						
						<form method="POST" onSubmit={this.handleClickAlerta}>
							<fieldset>
								<legend>Tarifas</legend>
								<div className="form-group">
									<label htmlFor="d_5km">5 Km</label>
									<input type="text" autoComplete="off" required placeholder="5 Km"
									defaultValue={this.state.d_5km} className="form-control"
									ref={input => {this.d_5km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_10km">10 Km</label>
									<input type="text" autoComplete="off" required placeholder="10 Km"
									defaultValue={this.state.d_10km} className="form-control"
									ref={input => {this.d_10km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_15km">15 Km</label>
									<input type="text" autoComplete="off" required placeholder="15 Km"
									defaultValue={this.state.d_15km} className="form-control"
									ref={input => {this.d_15km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_mas15km">Mayor a 15 km</label>
									<input type="text" autoComplete="off" required placeholder="Mayor a 15 Km"
									defaultValue={this.state.d_mas15km} className="form-control"
									ref={input => {this.d_mas15km=input;}}
									/>
								</div>
								
							</fieldset>
							
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>
			
			
					<footer class="footer-pg mt-auto py-3" style={{width:'100%', position:'fixed'}}>
					<div class="container">
						<div class="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div class="col-sm">
								<img src={copyright}/>
							</div>
						</div>
					</div>
					</footer>
				</div>

		)
		
		
	}
	
}

export default Tarifas;


// WEBPACK FOOTER //
// ./src/Components/Tarifas/Tarifas.jsx